import React, { useState, useEffect, useCallback } from 'react'
import { Bar, Logo } from './styles'
import LogoSvg from 'images/logos/logo-sm.svg'
import { withNamespaces } from 'react-i18next'
import { inject } from 'mobx-react'
import { employeeService } from 'services'
import Profile from './components/profile'
import Notifications from './components/notifications'
import NavToggle from 'components/Navigation/toggle'
import { TopSearch, useNavigation } from 'components/Navigation'
import { Trail } from 'components/Navigation/styles'
import { Link } from 'react-router-dom'

/** Barra colorida do topo: menu, caminho da tela, busca (Ctrl+K), notificações e perfil. */
const Menu = ({ t, rootStore }) => {
  const { email } = rootStore.authStore
  const { mode, trail } = useNavigation()
  const [employee, setEmployee] = useState()
  const isStaging =
    window.location.hostname.includes('staging') || window.location.hostname.includes('localhost')

  const getEmployeeByEmail = useCallback(async () => {
    const responseEmployee = await employeeService.getByEmail(email)
    if (responseEmployee) {
      setEmployee(responseEmployee)
      rootStore.authStore.employee = responseEmployee
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [email])

  useEffect(() => {
    getEmployeeByEmail()
  }, [getEmployeeByEmail])

  const reloadEmployee = () => {
    getEmployeeByEmail()
  }

  // fora do computador só cabe o nome da tela atual
  const crumbs = mode === 'sidebar' ? trail || [] : (trail || []).slice(-1)

  return (
    <Bar id={'ps-menu'} isStaging={isStaging} mode={mode}>
      <div className="ps-bar-left">
        <NavToggle />
        {mode !== 'sidebar' && (
          <Link to={'/'} aria-label={t('menu.logo')}>
            <Logo>
              <img src={LogoSvg} alt={t('menu.logo')} />
            </Logo>
          </Link>
        )}
        {crumbs.length > 0 && (
          <Trail aria-label={t('nav.youAreHere', 'Você está em')}>
            {crumbs.map((crumb, index) => (
              <React.Fragment key={`${crumb}-${index}`}>
                {index > 0 && <i className="sep fas fa-chevron-right" aria-hidden="true" />}
                <span className="crumb" title={crumb}>
                  {crumb}
                </span>
              </React.Fragment>
            ))}
          </Trail>
        )}
      </div>
      {mode !== 'mobile' && (
        <div className="ps-bar-center">
          <TopSearch />
        </div>
      )}
      <div className="ps-bar-right">
        <Notifications />
        <Profile employee={employee} reloadEmployee={reloadEmployee} />
      </div>
    </Bar>
  )
}

export default withNamespaces()(inject('rootStore')(Menu))
